__turbopack_context__.v({
  "active": "style-module-scss-module__74DzBG__active",
  "blur": "style-module-scss-module__74DzBG__blur",
  "canceled": "style-module-scss-module__74DzBG__canceled",
  "center-grid-item": "style-module-scss-module__74DzBG__center-grid-item",
  "closed": "style-module-scss-module__74DzBG__closed",
  "contact-for-price": "style-module-scss-module__74DzBG__contact-for-price",
  "expired": "style-module-scss-module__74DzBG__expired",
  "grid": "style-module-scss-module__74DzBG__grid",
  "inactive": "style-module-scss-module__74DzBG__inactive",
  "label": "style-module-scss-module__74DzBG__label",
  "mobile-row": "style-module-scss-module__74DzBG__mobile-row",
  "node": "style-module-scss-module__74DzBG__node",
  "other": "style-module-scss-module__74DzBG__other",
  "row": "style-module-scss-module__74DzBG__row",
  "stat": "style-module-scss-module__74DzBG__stat",
  "status-label": "style-module-scss-module__74DzBG__status-label",
  "value": "style-module-scss-module__74DzBG__value",
});
